<template>
    <b-container>
        <b-row>
            <b-col>
                <div class="divider divider--gold mb-3"></div>

                <h1 class="mb-5 font-h1 font-thin">
                    CREATE A NEW USER
                </h1>

                <b-form @submit.prevent="onSubmit">
                    <b-form-group>
<!--                        <label>-->
<!--                            Name-->
<!--                        </label>-->
                        
                        <b-form-input
                            type="text"
                            class="tb-form-field mb-0 font-h3"
                            v-model="form.name"
                            placeholder="Name"
                            required>
                        </b-form-input>

<!--                        <label>-->
<!--                            Role-->
<!--                        </label>-->

<!--                        <b-form-select -->
<!--                            class=" mb-3 font-h3"-->
<!--                            v-model="form.role" -->
<!--                            :options="role_options"-->
<!--                            required>-->
<!--                        </b-form-select>-->

                        <custom-select
                            :options="role_options"
                            :heading="'Select a role'"
                            @option-selected="(option) => form.role = option.value">
                        </custom-select>

<!--                        <label>-->
<!--                            Email-->
<!--                        </label>-->
                        
                        <b-form-input
                            class="tb-form-field mb-3 font-h3"
                            type="email"
                            v-model="form.email"
                            placeholder="Email"
                            required>
                        </b-form-input>

<!--                        <label>-->
<!--                            Password-->
<!--                        </label>-->
                        
                        <b-form-input
                            class="tb-form-field mb-3 font-h3"
                            type="password"
                            v-model="form.password"
                            placeholder="Password"
                            required>
                        </b-form-input>

<!--                        <label>-->
<!--                            Confirm Password-->
<!--                        </label>-->
                        
                        <b-form-input
                            class="tb-form-field mb-3 font-h3"
                            type="password"
                            v-model="form.password_confirmation"
                            placeholder="Confirm Password"
                            required>
                        </b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary tb-button tb-button--blue font-h3 font-thin">
                        SUBMIT USER
                    </b-button>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import userRepository from "@/repository/users";
    import CustomSelect from "@/components/CustomSelect";

    export default {
        components: {
            CustomSelect
        },

        data() {
            return {
                form: {
                    name: "",
                    role: "",
                    email: "",
                    password: "",
                    password_confirmation: ""
                },
                errors:{},
                role_options: [
                    {
                        'value': 'ADMIN',
                        'text': 'Admin',
                    },
                    {
                        'value': 'CLIENT',
                        'text': 'Client'
                    }
                ]
                // role_options: [
                //     'ADMIN',
                //     'CLIENT'
                // ]
            }
        },

        methods: {            
            onSubmit() {
                userRepository.store(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'User Created',
                            text: 'New user successfully created.'
                        });

                        this.clear();
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });


            },

            clear() {
                for (let field in this.form) {
                    this.form[field] = "";
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    
</style>